// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleIconButton_toggle__3nu6K","activeToggle":"ToggleIconButton_activeToggle__2CCK8"};